"use client";

import React from "react";
import { Target, PenTool, Code, TrendingUp, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardTitle, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  id: 1,
  title: "Definición Legal",
  description: "Análisis técnico del Art. 17 LFPIORPI para identificar si tu operación califica como actividad vulnerable.",
  icon: Target,
  linkText: "Ver Artículo",
  linkUrl: "/GuideLFPIORPIPage"
}, {
  id: 2,
  title: "Actividades",
  description: "Catálogo detallado de umbrales de identificación y aviso para cada sector sujeto a cumplimiento.",
  icon: PenTool,
  linkText: "Explorar Sectores",
  linkUrl: "/GuideLFPIORPIPage"
}, {
  id: 3,
  title: "Sanciones",
  description: "Riesgos operativos y multas administrativas actualizadas por omisión de avisos ante la UIF.",
  icon: Code,
  linkText: "Consultar Multas",
  linkUrl: "/GuideLFPIORPIPage"
}, {
  id: 4,
  title: "Reforma 2025",
  description: "Impacto del nuevo Art. 62 y las facultades de inspección reforzadas para la autoridad fiscal.",
  icon: TrendingUp,
  linkText: "Leer Reforma",
  linkUrl: "/GuideLFPIORPIPage"
}];
export default function NdiceDeCumplimiento() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="233655" id="índice-de-cumplimiento" className="py-24 bg-background text-foreground">
      <div className="container mx-auto px-6 max-w-7xl">
        <div ref={headerRef} className={`text-center max-w-3xl mx-auto mb-16 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h3 className="text-sm font-semibold uppercase tracking-wider text-primary mb-3 font-default">
            Guía de Cumplimiento
          </h3>
          <h2 className="text-4xl md:text-5xl font-bold text-foreground font-default">
            Índice de Obligaciones LFPIORPI
          </h2>
        </div>

        <div ref={gridRef} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <Card key={service.id} data-index={i} className={`rounded-lg p-8 flex flex-col items-center text-center gap-0 border-border bg-card shadow-md hover:border-primary transition-all duration-200 ease-in-out ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
            transitionDelay: `${i * 100}ms`
          }}>
                <Icon className="w-12 h-12 text-primary mb-6 stroke-[1.5]" />
                <CardTitle className="font-default text-xl mb-4 text-foreground">
                  {service.title}
                </CardTitle>
                <CardDescription className="font-default text-base text-muted-foreground mb-8 leading-relaxed">
                  {service.description}
                </CardDescription>
                <div className="mt-auto">
                  <Link to={service.linkUrl} className="inline-flex items-center gap-2 text-sm font-semibold text-primary hover:text-primary-foreground/80 uppercase tracking-wide transition-colors group font-mono">
                    {service.linkText}
                    <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
                  </Link>
                </div>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}